import { MAIN_EVENT } from '../Actions';

export default function (state = {}, action) {
  switch (action.type) {
    case MAIN_EVENT:
      return action.payload;
    default:
      return state;
  }
}